import { getApi } from "./api_instance";

export const getKycRegistries = async (dispatch) => {
  try {
    return await getApi({
      apiUrl: "/api/kyc/registry/list",
      dispatch,
      sendToken: true,
    });
  } catch (error) {
    throw error;
  }
};
